import styled from 'styled-components';
import { COLORS, DEVICES, FONT_FAMILY } from '@Commons';
import { BorderedSearch } from '../../../../../components/search/search';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ManualAddressToggle = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  margin: 3px 0;
  display: flex;
  justify-content: flex-start;
  width: 450px;
  align-items: center;
  color: ${COLORS.darkBlue};
  line-height: 24px;
  font-size: 16px;
  cursor: pointer;

  @media ${DEVICES.mobileXL} {
    width: 400px;
  }

  @media ${DEVICES.mobileL} {
    width: 350px !important;
  }
  @media ${DEVICES.mobileM} {
    width: 300px !important;
  }
`;

export const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 450px;

  ${BorderedSearch} {
    width: 450px !important ;
  }
  @media ${DEVICES.mobileXL} {
    ${BorderedSearch} {
      width: 320px !important;
    }
  }

  @media ${DEVICES.mobileM} {
    ${BorderedSearch} {
      width: unset !important;
    }
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 16px 0 28px;
`;

export const FormContainer = styled.div`
  margin-right: 45px;
  @media ${DEVICES.mobileL} {
    margin-right: 0;
  }
`;

export const BeneAddressFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
